var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Small_Icons",
    "data-name": "Small Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        opacity: 0.25;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Front_End",
    "data-name": "Front End"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.407,44.5H46.577"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_8",
    "data-name": "Rounded Rectangle 8",
    className: "cls-1",
    d: "M24.5,31.412h1a5,5,0,0,1,5,5v8.176h-11V36.412A5,5,0,0,1,24.5,31.412Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_8_copy",
    "data-name": "Rounded Rectangle 8 copy",
    className: "cls-1",
    d: "M7.5,42.813V25.188m34.99,0V42.813"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_8_copy_2",
    "data-name": "Rounded Rectangle 8 copy 2",
    className: "cls-1",
    d: "M46.444,21.061l-3-12.39c0-1.755-2.362-3.178-5.275-3.178H11.8c-2.913,0-5.275,1.423-5.275,3.178l-3,12.39S3.677,24.5,9.975,24.5c3.1,0,5.769-2.261,6.952-4.032A10.416,10.416,0,0,0,24.985,24.5,8.2,8.2,0,0,0,32,21s2.334,3.5,7.995,3.5S46.444,21.061,46.444,21.061Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5,15l38-5,3,11s0.862,3.361-6,3-8-4-8-4a7.744,7.744,0,0,1-7,4c-5.215.094-9-4-9-4s-0.735,4.843-5,5-7-4-7-4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontend);
export default __webpack_public_path__ + "static/media/frontend.02e688b89f54fdda8a86b9f01e03a41a.svg";
export { ForwardRef as ReactComponent };